<template>
   <div class="custom-seekbar-video">
        <font-awesome-icon class="icon icon-seek-bar" :icon="!isVideoPlaying ? 'play' : 'pause'" @click="togglePlaySeekBar" />
        <SlideProgress 
            :video-duration="videoDuration" 
            :current-playing-time="currentPlayingTime"
            @setPlayer="setPlayerStatus"
            @setCurrentTime="setCurrentTimePlayer"
        />
        <label for="seek-time" class="remaining-time live" 
            v-touch-start="mouseDownLiveBtn" 
            v-touch-end="mouseUpLiveBtn" 
            @mousedown="mouseDownLiveBtn" 
            @mouseup="mouseUpLiveBtn" 
            v-if="isLive"
            :class="remainingTimeClass"
        >{{ remainingTimeStatus }}</label>
        
        <label for="seek-time" class="remaining-time" v-else>{{ remainingTimeStatus }}</label>
    </div>
</template>

<script>
import HelperMixins from "@/mixins/HelperMixins";
import SlideProgress from "@/components/SlideProgress";
export default {
   name: "SeekbarVideo",
   mixins: [ HelperMixins ],
   components: {
       SlideProgress
   },
   props: {
        videoDuration: {
            type: Number,
            default: 0
        },
        currentPlayingTime: {
            type: Number,
            default: 0
        },
        isLive: {
            type: Boolean,
            default: false
        },
        isVideoPlaying: {
            type: Boolean,
            default: false
        }
   },
   computed: {
        remainingTimeStatus() {
            if (!this.isLive) {
                let remainingTime = this.formatStreamTime(Math.round(this.videoDuration - this.currentPlayingTime));
                return `-${remainingTime}`;
            }
            else {
                return "LIVE";
            }
        },
        remainingTimeClass() {
            if (!this.videoDuration)
                return "";
            
            return (this.videoDuration - this.currentPlayingTime > 15) ? '' : 'now-live'
        }
   },
   data() {
        return {
        }
   },
    watch: {
        
    },
    mounted(){
    },
    methods: {
        setPlayerStatus(status) {
            this.$emit("setPlayer", status)
        },

      setCurrentTimePlayer(time) {
        this.$emit("setCurrentTime", time)
      },

      togglePlaySeekBar() {
        //   this.$emit("updateStatePlayingVideo", !this.isVideoPlaying);
        this.$emit("setPlayer", !this.isVideoPlaying)
      },

      mouseDownLiveBtn() {
          console.log("Live btn clicked")
        //  this.$emit("setPlayer", false)
      },

      mouseUpLiveBtn() {
         this.$nextTick(() => {
            this.$emit("setCurrentTime", this.videoDuration)
            this.$emit("setPlayer", true)
         })
      },
   }
};
</script>
<style lang="scss">
.custom-seekbar-video {
    display: flex;
    color: white;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 1rem 0.5rem;
    z-index: 3;
    position: relative;
    background-color: transparent;
    #custom-seekbar
    {
        cursor: pointer;
        height: 10px;
        outline: thin solid orange;
        -moz-outline: thin solid orange;
        -webkit-outline: thin solid orange;
        overflow: hidden;
        position: relative;
        width: 100%;
    }
    #custom-seekbar span
    {
        background-color: orange;
        position: absolute;
        top: 0;
        left: 0;
        height: 10px;
        width: 1px;
    }
    .remaining-time {
        //color: $color-primary;
        margin-bottom: 0;
        margin-left: 1rem;
        &.live {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &::before {
                content:"• ";
                color: #757575;
                margin-right: 5px;
                font-size: 30px;
            }
            &.now-live {
                &::before {
                    color: #f00;
                }
            }
        }
    }
    .icon-seek-bar {
        color: $color-primary;
        margin-right: 1rem;
        cursor: pointer;
    }

    //.tooltiptext::after {
    //    content: "";
    //    position: absolute;
    //    top: 100%;
    //    left: 50%;
    //    margin-left: -5px;
    //    border-width: 5px;
    //    border-style: solid;
    //    border-color: #f38080 transparent transparent transparent;
    //}

    /*Chrome*/
    @media screen and (-webkit-min-device-pixel-ratio:0) {
        input[type='range'] {
            -webkit-appearance: none;
            background-color: transparent;
            border: 1px solid $color-primary;
            height: 1rem;
            overflow-y: hidden;
            width: 100%;
            border-radius: 0.3rem;
        }

        input[type='range']::-webkit-slider-runnable-track {
            -webkit-appearance: none;
            height: 1rem;
            border-radius: 0.3rem;
            background-color: transparent;
        }

        input[type='range']::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            height: 2rem;
            width: 1rem;
            background: $color-white;
            border: 0;
            border-radius: unset;
            cursor: pointer;
            box-shadow: -100vw 0 0 100vw $color-primary;
            -moz-box-shadow: -100vw 0 0 100vw $color-primary;
            -webkit-box-shadow: -100vw 0 0 100vw $color-primary;
        }

        input[type='range']::-moz-range-thumb {
            -webkit-appearance: none;
            -moz-appearance: none;
            height: 2rem;
            width: 1rem;
            background: $color-primary;
            cursor: pointer;
            border: 0;
            border-radius: unset;
        }

    }
    /** FF*/
    input[type="range"]::-moz-range-progress {
        background-color: $color-primary;
    }
    input[type="range"]::-moz-range-track {
        background-color: transparent;
    }
    /* IE*/
    input[type="range"]::-ms-fill-lower {
        background-color:$color-primary;
    }
    input[type="range"]::-ms-fill-upper {
        background-color: transparent;
    }
}
</style>